import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import type { VideoStatus } from "@lib/domain";
import { PIPELINE_STAGES, VIDEO_STATUS } from "@lib/domain";

const STAGE_LABELS: Record<string, string> = {
  [VIDEO_STATUS.QUEUED]: "Queued",
  [VIDEO_STATUS.FETCHING_TRANSCRIPT]: "Fetching transcript",
  [VIDEO_STATUS.FORMATTING_TRANSCRIPT]: "Formatting content",
  [VIDEO_STATUS.GENERATING_QUESTIONS]: "Writing questions",
  [VIDEO_STATUS.READY]: "Ready",
};

const STAGE_ORDER = PIPELINE_STAGES;

export function ProgressStepper({ status }: { status: VideoStatus }) {
  const activeIndex = STAGE_ORDER.indexOf(status);
  const progress = activeIndex < 0 ? 0 : Math.round((activeIndex / (STAGE_ORDER.length - 1)) * 100);

  return (
    <div className="space-y-3">
      <Progress value={progress} />
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {STAGE_ORDER.filter((s) => s !== VIDEO_STATUS.READY).map((s) => {
          const done = activeIndex > STAGE_ORDER.indexOf(s);
          const current = activeIndex === STAGE_ORDER.indexOf(s);
          return (
            <Badge
              key={s}
              variant={done ? "success" : current ? "default" : "outline"}
              className="justify-center"
            >
              {STAGE_LABELS[s]}
            </Badge>
          );
        })}
      </div>
    </div>
  );
}